/**
 * Template Form Fields - Main coordinator
 * 
 * Refactored into smaller components for better maintainability
 */

import React from 'react';
import { Flex, Separator } from '@radix-ui/themes';
import { DeviceTemplate } from '../../types';
import BasicInfoFields from './BasicInfoFields';
import PowerInputFields from './PowerInputFields';
import PowerOutputFields from './PowerOutputFields';
import USBPortFields from './USBPortFields';
import BatteryFields from './BatteryFields';

interface TemplateFormFieldsProps {
  template: Partial<DeviceTemplate>;
  onChange: (updated: Partial<DeviceTemplate>) => void;
  showTypeSelector?: boolean;
}

const TemplateFormFields: React.FC<TemplateFormFieldsProps> = ({ 
  template, 
  onChange,
  showTypeSelector = true 
}) => {
  return (
    <Flex direction="column" gap="4">
      <BasicInfoFields 
        template={template} 
        onChange={onChange} 
        showTypeSelector={showTypeSelector}
      />

      <Separator size="4" />

      <PowerInputFields 
        template={template} 
        onChange={onChange}
      />

      {template.type === 'power-source' && (
        <BatteryFields 
          template={template} 
          onChange={onChange}
        />
      )}

      <PowerOutputFields 
        template={template} 
        onChange={onChange}
      />

      <USBPortFields 
        template={template} 
        onChange={onChange}
      />
    </Flex>
  );
};

export default TemplateFormFields;
